import axios from "axios";
let config = {};

const init = (inputConfig) => (config = inputConfig);

const get = async (url, options = {}) => {
  return axios.get(url, {
    headers: {
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
  //(response);
};
const customGet = async (url, options = {}, headers) => {
  return axios.get(url, {
    headers: {
      ...headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const post = async (url, data, options = {}) => {
  return axios.post(url, data, {
    headers: {
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const customPost = async (url, data, options = {}, headers) => {
  return axios.post(url, data, {
    headers: {
      ...headers,
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const patch = async (url, data, options = {}) => {
  return axios.patch(url, data, {
    headers: {
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const customPatch = async (url, data, options = {}, headers) => {
  return axios.patch(url, data, {
    headers: {
      ...headers,
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const customDel = async (url, options = {}, headers) => {
  return axios.delete(url, {
    headers: {
      ...headers,
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const customPut = async (url, data, options = {}, headers) => {
  return axios.put(url, data, {
    headers: {
      ...headers,
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const put = async (url, data, options = {}) => {
  return axios.put(url, data, {
    headers: {
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const del = async (url, options = {}) => {
  return axios.delete(url, {
    headers: {
      ...config.headers,
    },
    timeout: config.timeout,
    ...config.httpConfig,
    ...options,
  });
};

const httpService = {
  init,
  get,
  post,
  patch,
  put,
  del,
  customGet,
  customPatch,
  customPut,
  customDel,
  customPost,
};

export default httpService;
